(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["egift"]) return;
  try {
    
  $(function () {
    let windowWidth = $(window).width();
    if (windowWidth <= 768) {
      $('.egift_reco').slick({
        dots: true,
        slidesToShow: 1,
      });
    }

    $('.egift_steps_guide li').on('click', function () {
      let $parent = $(this).parents('ul');
      let $list = $parent.next();
      let num = $parent.find('li').index(this);
      $parent.find('li').removeClass('active');
      $(this).addClass('active');
      $list.find('li').hide();
      $list.find('li').eq(num).show();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    $('.popup_close').on('click', function () {
      $(this).parents('.popup').fadeOut(200);
      $('body').removeClass('fixed');
    });

    if ($('.popup').length > 0) {
      $('body').addClass('fixed');
    }
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.popup_contents').length) {
      $('.popup').fadeOut(200);
      $('body').removeClass('fixed');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
